import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["qr", "code"]
  static values = { code: String }

  showCode() {
    this.qrTarget.hidden = true
    this.codeTarget.hidden = false
  }

  showQr() {
    this.codeTarget.hidden = true
    this.qrTarget.hidden = false
  }

  async copy(event) {
    try {
      try {
        await navigator.clipboard.writeText(this.codeValue)
      } catch {
        this.copyLegacy()
      }

      const button = event.currentTarget
      const icon = button.querySelector("i")
      icon?.classList.replace("fa-copy", "fa-check")
      button.title = "Copiado!"
      clearTimeout(this.resetTimeout)
      this.resetTimeout = setTimeout(() => {
        icon?.classList.replace("fa-check", "fa-copy")
        button.title = button.getAttribute("aria-label")
      }, 2000)
    } catch (error) {
      console.error("Erro ao copiar código de cobrança:", error)
    }
  }

  copyLegacy() {
    const field = document.createElement("textarea")
    field.value = this.codeValue
    field.style.position = "fixed"
    field.style.opacity = "0"
    document.body.appendChild(field)
    field.select()

    try {
      if (!document.execCommand("copy")) throw new Error("Não foi possível copiar o código")
    } finally {
      field.remove()
    }
  }

  disconnect() {
    clearTimeout(this.resetTimeout)
  }
}
